import React from "react";
import atyant from "../imgAndpdf/atyant.jpg";
import "./About.css";

function About() {
  return (
    <div className="about-coantainer" id="about">
      <div className="about-parent">
        <div className="about-heading">
          <h2>About Me</h2>
          <span>Why choose Me</span>
        </div>
        <div className="about-card">
          
          {/* =================================================img=============================================*/}
          <div className="about-card-image">
            <img src={atyant}></img>
          </div>
          <div className="about-card-paragraph">
            <span>
             " Hi, my name is Atyant Kumar. I am from Uttar Pradesh city Noorpur
              District Bijnor I'm 20 Years Old. I Have done my Graduation BCA
              Bachelor of Application From IFTM University Moradabad
              UttarPradesh 2022.In Graduation I make 4 Project 1. Employee
              Mangement System (React.js) 2. Portfolio Website (React.js) 3.
              Ecommarce Website (React.js) 4. Make Croptocrncy Reader ( React.js)
              I have Good Knowledge In C programming Html css JavaScript React.js <br/> 
              Thank You "

            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;
